import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Input, TextArea } from "@progress/kendo-react-inputs";
import { CustomDropdown } from "../shared/customDropdown";
import { MMPreauthorizationInvestigations } from './mmPreauthorizationInvestigations';
import { MMPreauthorizationNoxes } from './mmPreauthorizationNoxes';
import { alertService } from '../../services/helpers/alert.service';
import { nomService } from '../../services/api/nom.service';
import { mmPreauthorizationService } from '../../services/api/mmPreauthorization.service';
import { utils } from "../../services/helpers/utils";

export const MMPreauthorization = (props) => {

    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const navigate = useNavigate();

    const partener = sessionStorage.getItem("idPartener");

    const param = {
        pacient: searchParams.get("pacient"),
        contract: searchParams.get("contract"),
        id: searchParams.get("id"),
    };
    const [isModified, setIsModified] = useState(false);
    const [preautorizare, setPreautorizare] = useState({});
    const [noxe, setNoxe] = useState([]);
    const [investigatii, setInvestigatii] = useState([]);
    
    const actualizareNoxe = (noxe) => {
        setNoxe(noxe);
    }

    // Dupa salvare se vor forta toate componentele sa se reafiseze pentru a-si actualiza id-urile
    const [refresh, setRefresh] = useState(false);

    useEffect(() => {

        // Setam consulatia
        if (param.id) {
            mmPreauthorizationService.getPreauthorization({ preauthorizationId: param.id })
                .then(response => {
                    if (response) {
                        setPreautorizare(response);                      
                    }
                });
        }
        else if (param.pacient && param.contract) {
            mmPreauthorizationService.getHeader({
                pacient: param.pacient,
                subscription: param.contract,
                partener: partener
            }).then(response => {
                    if (response) {
                        setPreautorizare(response);
                    }

                });
        }

    }, []);


    const handleChange = (event) => {
        
        const { name, value } = event.target;

        // daca value e obiect 
        if (typeof value === "object") {
            // Daca are id e dropdown
            if (value.hasOwnProperty("id")) {
                setPreautorizare((prevParams) => ({ ...prevParams, [name]: value.id }));
            }
            // Daca nu are id e data
            else {
                setPreautorizare((prevParams) => ({ ...prevParams, [name]: value }));
            }
        }
        else {
            setPreautorizare((prevParams) => ({ ...prevParams, [name]: value }));
        }

        setIsModified(true);
    }


    const verify = () => {
        if (!preautorizare.data) {
            alertService.error("Completati data!");
            return false;
        }

        if (!preautorizare.idProfesie) {    
            alertService.error("Completati profesia!");
            return false;
        }

        if (preautorizare.idTipFisa == null) {
            alertService.error("Completati tipul fisei!");
            return false;
        }

        if (noxe.length == 0) {
            alertService.error("Completati noxe!");
            return false;
        }


        if (noxe.length > 0) {
            for (var i = 0; i < noxe.length; i++) {
                if (!noxe[i].idNoxa) {
                    alertService.error("Completati investigatia de la randul " + (i + 1) + "!");
                    return false;
                }
            }
        }

        return true;
    }

    const handleCompletion = () => {
        if (!verify()) return;

        if (preautorizare.statusFinalizare == 1) {
            return
        }

        const updatedPreautorizare = { ...preautorizare, statusFinalizare: 1 };
        setPreautorizare(updatedPreautorizare);
        handleSave(updatedPreautorizare);
    };

    const handleSave = (paramPreautorizare) => {

        const savePreauto = paramPreautorizare.hasOwnProperty("id") ? paramPreautorizare : preautorizare;

        /* Verificari */
        if (!verify()) return

        /*  Salvare*/
        const save = {
            preautorizare: savePreauto,
            noxe: noxe
        }

        const isFinalizata = (savePreauto.statusFinalizare == 1);

        mmPreauthorizationService.savePreauthorization(save).then(response => {
            if (response) {

                setRefresh(!refresh);
                if (!preautorizare.id && response.id) {
                    const updatedPreautorizare = { ...preautorizare, id: response.id };
                    setPreautorizare(updatedPreautorizare);
                }

                const message = (isFinalizata) ? "Preautorizarea a fost finalizata cu succes!" : "Preautorizarea a fost salvata cu succes!";
                alertService.success(message);

                setIsModified(false);
            }
        });
        
    };
   

    const handleClose = () => {

        if (preautorizare.statusFinalizare == 1) {
            navigate(-1);
            return;
        }

        if (isModified) {
            alertService.confirm("Atentie", "Datele au fost modificate. Renuntati la modificari?",
                () => { navigate(-1); },
                () => { return });
        }
        else {
            navigate(-1);
        }
    };


    return (
        <>
            <h2 className="pt20 pb20">Cerere de preautorizare</h2>
            <div className="formular">
                <fieldset>
                    <div className="clearfix">
                        <div className="fl">
                            <label className="pb5">CNP:</label> 
                            <Input name="cnp" readOnly value={preautorizare.cnp} disabled={ true} />

                            <label className="pt10 pb5">Nume:</label>
                            <Input  name="nume" readOnly value={preautorizare.nume} disabled={true} />

                            <label className="pt10 pb5">Prenume:</label>
                            <Input name="prenume" readOnly value={preautorizare.prenume} disabled={true} />

                            <label className="pt10 pb5">Firma:</label>
                            <Input name="abonament" readOnly value={preautorizare.firma} disabled={true} />

                            <label className="pt10 pb5">Profesie: <span className="red">*</span></label>
                            <CustomDropdown name="idProfesie"
                                request={nomService.getProfessionsByContract}
                                requestParams={{ contract: utils.valueorzero(preautorizare.idAbonament) }}
                                initialValue={preautorizare.idProfesie}
                                onChangeEvent={handleChange}
                                disabled={preautorizare.statusFinalizare == 1}
                            />
                            

                            <label className="pt10 pb5">Tip fisa: <span className="red">*</span></label>
                            <CustomDropdown name="idTipFisa"
                                request={nomService.getRrecordsType}
                                initialValue={preautorizare.idTipFisa}
                                onChangeEvent={handleChange}
                                disabled={preautorizare.statusFinalizare == 1}
                            />

                        </div>

                        <div className="fr">
                            <fieldset>
                                <label className="pb5">Partener:</label>
                                <Input name="id_partener" readOnly value={preautorizare.partener} disabled={true} />

                                <MMPreauthorizationNoxes id={preautorizare.id} actualizareNoxe={actualizareNoxe} statusFinalizare={preautorizare.statusFinalizare} />
                                
                            </fieldset>
                        </div>
                    </div>
                </fieldset>

                <MMPreauthorizationInvestigations
                    id={preautorizare.id}
                    noxe={noxe}
                    tipFisa={preautorizare.idTipFisa}
                    setInvestigatii={setInvestigatii}
                    
                />

                <fieldset>
                    <legend className="pt10 pb5">Observatii</legend>
                    <TextArea
                        name="observatii"
                        className=""
                        value={preautorizare.observatii}
                        disabled={preautorizare.statusFinalizare == 1}
                        onChange={handleChange}
                    />
                </fieldset>
                <p className="paragraf red mt15">Campurile marcate cu * sunt obligatorii.</p>
            </div>

            <div className="clearfix pt20 pb20">
                <div className="col50p">
                    <button className="btn" name="back" onClick={handleClose}>Inchide</button>
                </div>
                <div className="col50p right">
                    {preautorizare.statusFinalizare != 1 &&
                        <>
                            <button className="btn" name="save" onClick={handleSave}>Salveaza</button>
                            <button className="btn" name="finalizeaza" onClick={handleCompletion}>Finalizeaza</button>
                        </>
                    }
                </div>
            </div>
        </>
    );
};


